import { render, staticRenderFns } from "./PersonFacts.vue?vue&type=template&id=896478f0&scoped=true&"
import script from "./PersonFacts.vue?vue&type=script&lang=js&"
export * from "./PersonFacts.vue?vue&type=script&lang=js&"
import style0 from "./PersonFacts.vue?vue&type=style&index=0&id=896478f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896478f0",
  null
  
)

export default component.exports